/* Caracol Quiz — lógica de recomendación (pura, sin DOM). Edita aquí las reglas. */
var CQ_LOGIC = (function () {
  var PIEL = {
    seca:   { klaviyo: 'piel seca',   titulo: 'Es probable que tengas piel seca',   texto: 'Tu piel tiende a sentirse tirante y a perder hidratación durante el día. Necesita nutrición y cuidar su barrera protectora.' },
    normal: { klaviyo: 'piel normal', titulo: 'Es probable que tengas piel normal', texto: 'Tu piel está en equilibrio: ni muy grasa ni muy seca. La clave es mantenerla hidratada y tratar lo que más te importa.' },
    mixta:  { klaviyo: 'piel mixta',  titulo: 'Es probable que tengas piel mixta',  texto: 'Tu zona T (frente, nariz y mentón) tiende a brillar, mientras las mejillas pueden sentirse más secas. Necesita equilibrio sin resecar.' },
    grasa:  { klaviyo: 'piel grasa',  titulo: 'Es probable que tengas piel grasa',  texto: 'Tu piel produce más sebo y tiende a brillar durante el día. Necesita hidratación ligera, libre de aceites, que regule la grasitud.' }
  };

  var NECESIDAD = {
    acne:       'tratar el acné y los granitos',
    brillo:     'controlar el brillo y la oleosidad',
    manchas:    'disminuir y prevenir las manchas',
    hidratacion:'hidratar y dar luminosidad a tu piel',
    lineas:     'reducir y prevenir líneas de expresión',
    firmeza:    'rellenar arrugas y dar firmeza'
  };

  var P = {
    acneControl: 'acne-control-1',
    megaRegenerador: 'mega-pack-rutina-completa-libre-de-aceites-1',
    powerDuo: 'pack-power-duo-combate-acne-y-reduce-manchas',
    regenerador: 'pack-hidratacion-libre-de-aceites',
    antiAge: 'pack-humectante-anti-age-1',
    reafirmante: 'pack-rejuvenecedor-humectante-intenso-1',
    antiManchas: 'pack-anti-manchas-1',
    dobleLimpieza: 'doble-limpieza-natural',
    hRefresh: 'pack-hombre-refresh-skin',
    hAgeReset: 'pack-hombre-age-reset',
    miPrimer: 'mi-primer-caracol',
    hMega360: 'pack-hombre-mega-pack-360',
    cremaGel: 'crema-gel-de-regeneracion',
    serum: 'suero-rejuvenecedor',
    contorno: 'crema-contorno-de-ojos',
    unifying: 'crema-aclaradora-unificante',
    antiEdad: 'crema-anti-edad-anti-arrugas',
    cremaReafirmante: 'crema-reafirmante-restauradora'
  };

  var R = {
    b_cremaGel: { titulo: 'Crema Gel de Regeneración', items: [P.cremaGel],
      desc: 'Regenera e hidrata con una textura ligera libre de aceites, equilibra la grasitud y ayuda a combatir granitos y espinillas.' },
    b_antiEdad: { titulo: 'Crema Anti Age', items: [P.antiEdad],
      desc: 'Rellena y ayuda a retrasar la formación de nuevas arrugas, con ácido hialurónico de doble peso molecular y complejo de 3 ceramidas. Para todo tipo de piel.' },
    b_reafirmante: { titulo: 'Crema Reafirmante', items: [P.cremaReafirmante],
      desc: 'Ayuda a redefinir el contorno facial, suavizar arrugas y nutrir en profundidad las pieles maduras.' },
    b_unifying: { titulo: 'Crema Unifying Anti Manchas', items: [P.unifying],
      desc: 'Ayuda a reducir manchas solares, hormonales, de acné y de embarazo, unificando el tono del rostro, cuello y escote.' },
    s_miPrimer: { titulo: 'Mi Primer Caracol', items: [P.miPrimer],
      desc: 'Rutina simple de 2 pasos (Mousse de Limpieza + Crema Gel de Regeneración), ideal si es tu primera vez con Caracol.' },
    s_hRefresh: { titulo: 'Pack Refresh Skin', items: [P.hRefresh],
      desc: 'Rutina minimalista de 2 pasos sin aceites para limpiar, hidratar y equilibrar la piel. Ideal también como aftershave.' },
    s_hAgeReset: { titulo: 'Pack Age Reset', items: [P.hAgeReset],
      desc: 'Rutina anti-edad esencial de 2 pasos: Mousse de Limpieza + Crema Anti Age para suavizar líneas y rellenar arrugas.' },
    f_acneControl: { titulo: 'Pack Acné Control', items: [P.acneControl],
      desc: 'Mousse de Limpieza + Tónico Esencial + Crema Gel de Regeneración: limpia sin agredir, equilibra y ayuda a controlar los brotes.' },
    f_powerDuo: { titulo: 'Pack Power Duo', items: [P.powerDuo],
      desc: 'Rutina día y noche para combatir granitos y tratar manchas al mismo tiempo: Mousse, Tónico y Crema Gel de día + Crema Unifying de noche.' },
    f_regenerador: { titulo: 'Pack Regenerador', items: [P.regenerador],
      desc: 'Rutina de 4 pasos que regenera, hidrata, controla la oleosidad y mejora la textura y los poros, sin sensación pesada.' },
    f_megaRegenerador: { titulo: 'Mega Pack Regenerador', items: [P.megaRegenerador],
      desc: 'La rutina completa en 5 pasos, con Serum Contorno de Ojos incluido: regenera, hidrata, controla la grasitud y suaviza líneas de expresión.' },
    f_antiAge: { titulo: 'Pack Anti Age', items: [P.antiAge],
      desc: 'Limpiar, preparar, tratar y sellar: rellena arrugas y ayuda a restaurar la barrera protectora de la piel.' },
    f_reafirmante: { titulo: 'Pack Reafirmante', items: [P.reafirmante],
      desc: 'Rutina intensiva para pieles maduras: ayuda a combatir la flacidez, suavizar arrugas y recuperar firmeza y luminosidad.' },
    f_antiManchas: { titulo: 'Pack Anti Manchas', items: [P.antiManchas],
      desc: 'Rutina de 4 pasos para tratar y prevenir manchas solares, de acné, hormonales o de embarazo, con una piel más uniforme.' },
    f_hMega360: { titulo: 'Mega Pack 360', items: [P.hMega360],
      desc: 'Rutina completa de 4 pasos para una piel más firme, luminosa y equilibrada, con Serum Contorno de Ojos incluido.' },
    c_dobleLimpieza: { titulo: 'Doble Limpieza Natural', items: [P.dobleLimpieza],
      desc: 'Si usas maquillaje o protector solar a diario: el Instant Cleansing Balm los disuelve y el Mousse termina la limpieza.' },
    c_contorno: { titulo: 'Serum Contorno de Ojos', items: [P.contorno],
      desc: 'Ayuda a desinflamar, aclarar ojeras y suavizar líneas del contorno de ojos.' }
  };

  var CON_CONTORNO = ['f_megaRegenerador', 'f_hMega360'];

  function pielDesdeRespuesta(r) {
    return { seca: 'seca', igual: 'normal', mixta: 'mixta', brilla: 'grasa' }[r] || 'normal';
  }

  function recomendar(a) {
    var x = {}; (a.extras || []).forEach(function (e) { x[e] = true; });
    var oleosa = a.piel === 'grasa' || a.piel === 'mixta';
    var madura = a.edad === '40' || a.edad === '50';
    var b, f, simple = null;

    switch (a.necesidad) {
      case 'acne': case 'brillo': b = 'b_cremaGel'; break;
      case 'manchas': b = 'b_unifying'; break;
      case 'hidratacion': b = a.piel === 'seca' ? 'b_antiEdad' : 'b_cremaGel'; break;
      case 'lineas': b = 'b_antiEdad'; break;
      case 'firmeza': b = (madura || a.piel === 'seca') ? 'b_reafirmante' : 'b_antiEdad'; break;
      default: b = 'b_cremaGel';
    }

    if (a.para === 'hombre') {
      if (a.necesidad === 'manchas') f = 'f_antiManchas';
      else if (a.piel === 'seca') f = 'f_antiAge';
      else f = 'f_hMega360';
      simple = (a.piel === 'seca' || a.necesidad === 'lineas' || a.necesidad === 'firmeza') ? 's_hAgeReset' : (a.necesidad === 'manchas' ? null : 's_hRefresh');
    } else {
      switch (a.necesidad) {
        case 'acne': f = x.manchas ? 'f_powerDuo' : 'f_acneControl'; break;
        case 'manchas': f = x.granitos ? 'f_powerDuo' : 'f_antiManchas'; break;
        case 'brillo': f = x.ojeras ? 'f_megaRegenerador' : 'f_regenerador'; break;
        case 'hidratacion':
          if (a.piel === 'seca') f = 'f_antiAge';
          else if (oleosa) f = 'f_megaRegenerador';
          else f = x.ojeras ? 'f_megaRegenerador' : 'f_regenerador';
          break;
        case 'lineas': f = oleosa ? 'f_megaRegenerador' : 'f_antiAge'; break;
        case 'firmeza': f = (madura || a.piel === 'seca') ? 'f_reafirmante' : 'f_antiAge'; break;
        default: f = 'f_regenerador';
      }
      if (x.primera && a.piel !== 'seca' && ['acne', 'brillo', 'hidratacion'].indexOf(a.necesidad) > -1) simple = 's_miPrimer';
    }

    var extras = [];
    if (x.maquillaje) extras.push('c_dobleLimpieza');
    if (x.ojeras && CON_CONTORNO.indexOf(f) === -1) extras.push('c_contorno');

    var notas = [];
    if (x.embarazo) notas.push('embarazo');
    if (x.sensible) notas.push('sensible');

    return { basica: b, full: f, simple: simple, extras: extras, notas: notas };
  }

  return { PIEL: PIEL, NECESIDAD: NECESIDAD, R: R, P: P, recomendar: recomendar, pielDesdeRespuesta: pielDesdeRespuesta };
})();

/* Caracol Quiz — interfaz. Requiere CQ_LOGIC y window.CQ_CONFIG */
(function () {
  var C = window.CQ_CONFIG || {};
  var L = CQ_LOGIC;
  var root = document.getElementById('caracol-quiz');
  if (!root) return;

  var KLAVIYO_REVISION = '2024-10-15';
  var state = { nombre: '', para: '', edad: '', pielResp: '', piel: '', necesidad: '', extras: [], email: '' };
  var history = [];
  var current = 'intro';
  var started = false;

  var Q = {
    para: { titulo: function () { return 'Hola ' + esc(state.nombre) + ', ¿para quién es la rutina?'; },
      opciones: [['mujer', 'Para mí / mujer', '🌸'], ['hombre', 'Para hombre', '🧔']], dos: true },
    edad: { titulo: function () { return '¿En qué rango de edad estás?'; },
      opciones: [['-20', 'Menos de 20'], ['20', '20 a 29'], ['30', '30 a 39'], ['40', '40 a 49'], ['50', '50 o más']] },
    pielResp: { titulo: function () { return '¿Cómo sientes tu piel al final del día?'; },
      sub: 'Piensa en un día normal, sin productos.',
      opciones: [
        ['seca', 'Tirante y seca, a veces con descamación o irritación', '🏜️'],
        ['igual', 'Igual que en la mañana, ¡bien!', '🙂'],
        ['mixta', 'Mejillas secas, pero frente y nariz brillantes', '🌗'],
        ['brilla', 'Brillante en todo el rostro a lo largo del día', '✨']] },
    necesidad: { titulo: function () { return '¿Qué es lo que más quieres mejorar hoy?'; },
      sub: 'Elige tu prioridad principal.',
      opciones: [
        ['acne', 'Acné, granitos y sus marcas', '🎯'],
        ['brillo', 'Brillo en zona T, oleosidad y poros', '💧'],
        ['manchas', 'Manchas y tono disparejo', '☀️'],
        ['hidratacion', 'Hidratación y luminosidad', '🌟'],
        ['lineas', 'Líneas de expresión (primeras arrugas)', '〰️'],
        ['firmeza', 'Arrugas, flacidez y firmeza', '🌿']] },
    extras: { titulo: function () { return '¿Algo más que debamos saber?'; },
      sub: 'Puedes marcar varias o ninguna.', multi: true,
      opciones: [
        ['granitos', 'También me salen granitos'],
        ['manchas', 'También tengo manchas'],
        ['ojeras', 'Me preocupan las ojeras o el contorno de ojos'],
        ['maquillaje', 'Uso maquillaje o protector solar a diario'],
        ['primera', 'Es mi primera vez usando Caracol'],
        ['sensible', 'Tengo piel muy sensible o rosácea'],
        ['embarazo', 'Estoy embarazada o en lactancia']] }
  };
  var ORDER = ['intro', 'nombre', 'para', 'edad', 'pielResp', 'piel', 'necesidad', 'extras', 'email', 'result'];
  var STEP_NAMES = { nombre: 'Nombre', para: 'Para quién', edad: 'Edad', pielResp: 'Tipo de piel', piel: 'Resultado tipo de piel', necesidad: 'Necesidad', extras: 'Extras', email: 'Email', result: 'Resultado' };

  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function prod(h) { return (C.products || {})[h]; }
  function onSale(p) { return !!(p && p.compare && p.compare > p.price); }
  function progress() {
    var i = ORDER.indexOf(current), n = ORDER.length - 2;
    return Math.max(0, Math.min(100, Math.round((i / n) * 100)));
  }
  function primerNombre() { return (state.nombre || '').trim().split(' ')[0]; }

  function track(name, props) {
    props = props || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, props)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
    if (C.preview) { try { console.log('[quiz evento]', name, props); } catch (e) {} }
  }

  function kPost(path, body) {
    if (C.preview || !C.klaviyoKey) return Promise.resolve('preview');
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(C.klaviyoKey), {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(body)
    });
  }

  function enviarKlaviyo(rec) {
    var props = {
      'Tipo de piel': L.PIEL[state.piel].klaviyo,
      'Quiz - Necesidad': L.NECESIDAD[state.necesidad],
      'Quiz - Edad': labelOf('edad', state.edad),
      'Quiz - Para': state.para,
      'Quiz - Extras': state.extras.map(function (e) { return labelOf('extras', e); }).join(', '),
      'Quiz - Recomendación básica': L.R[rec.basica].titulo,
      'Quiz - Rutina recomendada': L.R[rec.full].titulo,
      'Quiz - Rutina simple': rec.simple ? L.R[rec.simple].titulo : '',
      'Quiz - Fecha': new Date().toISOString()
    };
    var basicaItems = L.R[rec.basica].items.map(itemPayload);
    var fullItems = L.R[rec.full].items.map(itemPayload);
    var profileAttrs = { email: state.email, first_name: primerNombre(), properties: props };

    var calls = [
      kPost('profiles', { data: { type: 'profile', attributes: profileAttrs } }),
      kPost('events', { data: { type: 'event', attributes: {
        properties: Object.assign({}, props, {
          'Código descuento': C.code, 'Básica': L.R[rec.basica].titulo, 'Básica productos': basicaItems,
          'Rutina': L.R[rec.full].titulo, 'Rutina productos': fullItems,
          'Complementos': rec.extras.map(function (k) { return L.R[k].titulo; })
        }),
        metric: { data: { type: 'metric', attributes: { name: 'Quiz Completado' } } },
        profile: { data: { type: 'profile', attributes: { email: state.email } } }
      } } })
    ];
    if (C.listId) {
      calls.push(kPost('subscriptions', { data: { type: 'subscription', attributes: {
        custom_source: 'Quiz Caracol',
        profile: { data: { type: 'profile', attributes: { email: state.email } } }
      }, relationships: { list: { data: { type: 'list', id: C.listId } } } } }));
    }
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: state.email, first_name: primerNombre() }); } catch (e) {}
    var timeout = new Promise(function (r) { setTimeout(r, 3500); });
    return Promise.race([Promise.all(calls.map(function (p) { return p.catch(function () {}); })), timeout]);
  }
  function itemPayload(h) {
    var p = prod(h) || {};
    return { handle: h, nombre: p.title || h, precio: p.price || 0, en_oferta: onSale(p), url: p.url ? (location.origin + p.url) : '', imagen: p.img ? (p.img.indexOf('//') === 0 ? 'https:' + p.img : p.img) : '' };
  }
  function labelOf(q, v) {
    var o = (Q[q].opciones || []).filter(function (x) { return x[0] === v; })[0];
    return o ? o[1] : v;
  }

  function go(step, push) {
    if (push !== false && current !== step) history.push(current);
    current = step;
    if (step !== 'intro' && step !== 'result') track('quiz_step', { quiz_step: STEP_NAMES[step], quiz_step_index: ORDER.indexOf(step) });
    render();
    var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }
  function back() { if (history.length) { current = history.pop(); render(); } }
  function next() { go(ORDER[ORDER.indexOf(current) + 1]); }

  function shell(inner, opts) {
    opts = opts || {};
    var bar = opts.noBar ? '' : '<div class="cq-progress"><span style="width:' + progress() + '%"></span></div>';
    var actions = '';
    if (!opts.noActions) {
      actions = '<div class="cq-actions">' +
        (history.length && !opts.noBack ? '<button type="button" class="cq-back" data-act="back">← Volver</button>' : '<span></span>') +
        (opts.nextLabel ? '<button type="button" class="cq-btn ' + (opts.accent ? 'cq-accent' : '') + '" data-act="next" ' + (opts.disabled ? 'disabled' : '') + '>' + opts.nextLabel + '</button>' : '') +
        '</div>';
    }
    root.innerHTML = '<div class="cq">' + bar + '<div class="cq-step">' + inner + '</div>' + actions + '</div>';
  }

  function render() {
    var r = { intro: rIntro, nombre: rNombre, piel: rPiel, email: rEmail, result: rResult }[current];
    if (r) return r();
    rQuestion(current);
  }

  function rIntro() {
    shell(
      '<div class="cq-intro"><span class="cq-badge">Quiz Caracol</span>' +
      '<h2 style="margin-top:14px">¿Cuál es tu rutina ideal?</h2>' +
      '<p class="cq-sub">Responde 6 preguntas rápidas y te recomendamos la rutina perfecta para tu tipo de piel.</p>' +
      '<div class="cq-perks"><span>⏱ 1 minuto</span><span>🐌 Recomendación personalizada</span><span>🎁 ' + esc(C.pct) + '% OFF</span></div>' +
      '<button type="button" class="cq-btn cq-accent" data-act="start">Comenzar</button></div>',
      { noBar: true, noActions: true });
  }

  function rNombre() {
    shell('<h2>Antes de partir, ¿cómo te llamas?</h2>' +
      '<input class="cq-input" id="cq-nombre" type="text" autocomplete="given-name" maxlength="40" placeholder="Tu nombre" value="' + esc(state.nombre) + '">' +
      '<div class="cq-err" id="cq-err"></div>',
      { nextLabel: 'Continuar', disabled: !state.nombre.trim() });
    var i = root.querySelector('#cq-nombre');
    i.focus();
    i.addEventListener('input', function () { state.nombre = i.value; root.querySelector('[data-act=next]').disabled = !i.value.trim(); });
    i.addEventListener('keydown', function (e) { if (e.key === 'Enter' && i.value.trim()) { e.preventDefault(); next(); } });
  }

  function rQuestion(key) {
    var q = Q[key];
    var val = state[key];
    var html = '<h2>' + q.titulo() + '</h2>' + (q.sub ? '<p class="cq-sub">' + q.sub + '</p>' : '') +
      '<div class="cq-options ' + (q.dos ? 'cq-two' : '') + '">' +
      q.opciones.map(function (o) {
        var on = q.multi ? val.indexOf(o[0]) > -1 : val === o[0];
        return '<button type="button" class="cq-opt ' + (on ? 'is-on' : '') + '" data-opt="' + o[0] + '">' +
          (o[2] ? '<span class="cq-ico">' + o[2] + '</span>' : '') + '<span>' + o[1] + '</span>' +
          (q.multi ? '<span class="cq-check">✓</span>' : '') + '</button>';
      }).join('') + '</div>';
    shell(html, q.multi ? { nextLabel: val.length ? 'Continuar' : 'Nada más, continuar' } : {});
    root.querySelectorAll('[data-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-opt');
        if (q.multi) {
          var i = state[key].indexOf(v);
          if (i > -1) state[key].splice(i, 1); else state[key].push(v);
          b.classList.toggle('is-on');
          root.querySelector('[data-act=next]').textContent = state[key].length ? 'Continuar' : 'Nada más, continuar';
          return;
        }
        state[key] = v;
        if (key === 'pielResp') state.piel = L.pielDesdeRespuesta(v);
        b.classList.add('is-on');
        setTimeout(next, 220);
      });
    });
  }

  function rPiel() {
    var p = L.PIEL[state.piel];
    shell('<div class="cq-skin"><span class="cq-badge">Tu tipo de piel</span><h2>' + p.titulo + '</h2><p>' + p.texto + '</p></div>',
      { nextLabel: 'Continuar' });
  }

  function rEmail() {
    shell('<span class="cq-badge" style="display:table;margin:0 auto 14px">¡Tu rutina está lista!</span>' +
      '<h2>' + esc(primerNombre()) + ', ¿dónde te enviamos tu rutina?</h2>' +
      '<p class="cq-sub">Déjanos tu mail para ver tu recomendación y recibir tu código de <b>' + esc(C.pct) + '% OFF</b>.</p>' +
      '<div id="cq-form"><input class="cq-input" id="cq-email" type="email" autocomplete="email" inputmode="email" placeholder="tu@email.com" value="' + esc(state.email) + '">' +
      '<div class="cq-err" id="cq-err"></div>' +
      '<button type="button" class="cq-btn cq-accent cq-block" id="cq-submit">Ver mi rutina</button></div>' +
      '<p class="cq-legal">Al continuar aceptas recibir correos de Caracol con tu rutina, novedades y promociones. Puedes darte de baja cuando quieras.</p>',
      {});
    var i = root.querySelector('#cq-email'), sending = false;
    i.focus();
    root.querySelector('#cq-submit').addEventListener('click', enviar);
    i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); enviar(); } });
    function enviar() {
      if (sending) return;
      var v = i.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { root.querySelector('#cq-err').textContent = 'Revisa tu mail, parece que tiene un error.'; return; }
      state.email = v; sending = true;
      var btn = root.querySelector('#cq-submit');
      btn.disabled = true; btn.innerHTML = '<span class="cq-spin"></span>';
      var rec = L.recomendar(state);
      enviarKlaviyo(rec).then(function () {
        track('quiz_complete', { quiz_skin_type: L.PIEL[state.piel].klaviyo, quiz_need: state.necesidad, quiz_routine: L.R[rec.full].titulo, quiz_basic: L.R[rec.basica].titulo });
        track('generate_lead', { lead_source: 'quiz' });
        try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'Quiz Caracol' }); } catch (e) {}
        go('result');
      });
    }
  }

  function recCard(key, kind, full) {
    var r = L.R[key];
    var items = r.items.map(prod).filter(Boolean);
    var pct = (parseFloat(C.pct) || 0) / 100;
    var antes = 0, final = 0, nElig = 0;
    items.forEach(function (p) {
      antes += onSale(p) ? p.compare : p.price;
      if (onSale(p)) final += p.price; else { final += p.price * (1 - pct); nElig++; }
    });
    var label = nElig === items.length ? 'Con tu ' + esc(C.pct) + '% OFF' : (nElig === 0 ? 'Precio oferta' : 'Precio final');
    var soldOut = items.some(function (p) { return p.available === false; });
    return '<div class="cq-rec ' + (full ? 'cq-full' : '') + '">' +
      '<div class="cq-rec-head"><span class="cq-rec-kind">' + kind + '</span>' + (full ? '<span class="cq-badge">Recomendada</span>' : '') + '</div>' +
      '<h3>' + r.titulo + '</h3><p class="cq-desc">' + r.desc + '</p>' +
      '<div class="cq-items">' + items.map(function (p) {
        return '<a class="cq-item" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') +
          '<span><span class="cq-item-t">' + esc(p.title) + '</span><br><span class="cq-item-p">' + money(p.price) +
          (onSale(p) ? ' <s>' + money(p.compare) + '</s> · Ya en oferta (no aplica código)' : '') + (p.available === false ? ' · Agotado' : '') + '</span></span></a>';
      }).join('') + '</div>' +
      '<div class="cq-rec-foot"><span class="cq-total">' + label + '<b>' + money(final) + '</b>' + (antes > final ? '<s>' + money(antes) + '</s>' : '') + '</span>' +
      '<button type="button" class="cq-btn ' + (full ? 'cq-accent' : 'cq-ghost') + '" data-add="' + key + '" ' + (soldOut ? 'disabled' : '') + '>' + (soldOut ? 'Agotado' : 'Agregar al carro') + '</button></div></div>';
  }

  function rResult() {
    var rec = L.recomendar(state);
    var notas = rec.notas.map(function (n) {
      if (n === 'embarazo') return '<div class="cq-note">🤰 Si estás embarazada o en lactancia, te recomendamos consultar con tu médico antes de incorporar productos nuevos. Revisa nuestra <a href="' + esc(C.embarazoUrl) + '">selección para embarazo y lactancia</a>.</div>';
      if (n === 'sensible') return '<div class="cq-note">🌿 Si tu piel es muy sensible o tienes rosácea, escríbenos y te asesoramos para elegir tu rutina: <a href="' + esc(C.whatsapp) + '" target="_blank" rel="noopener">hablar por WhatsApp</a>.</div>';
      return '';
    }).join('');
    var extras = rec.extras.length ? '<div class="cq-extra"><h3>Súmale a tu rutina</h3><div class="cq-recs">' + rec.extras.map(function (k) { return recCard(k, 'Complemento', false); }).join('') + '</div></div>' : '';
    shell(
      '<h2>' + esc(primerNombre()) + ', esta es tu rutina para ' + L.NECESIDAD[state.necesidad] + ' 🧡</h2>' +
      '<p class="cq-sub">Pensada para ' + L.PIEL[state.piel].klaviyo + '. También te la enviamos a tu mail.</p>' +
      '<div class="cq-code"><span><small>Tu ' + esc(C.pct) + '% OFF en tu recomendación</small><b>' + esc(C.code) + '</b><small>' + esc(C.codeNote || '') + '</small></span>' +
      '<button type="button" class="cq-copy" data-act="copy">Copiar código</button></div>' +
      notas +
      '<div class="cq-recs">' + recCard(rec.full, 'Rutina completa', true) + recCard(rec.basica, 'Opción básica', false) + '</div>' +
      (rec.simple ? '<div class="cq-extra"><h3>¿Prefieres partir simple?</h3><div class="cq-recs">' + recCard(rec.simple, 'Rutina de 2 pasos', false) + '</div></div>' : '') +
      extras +
      '<button type="button" class="cq-back cq-redo" data-act="redo">↻ Rehacer el quiz</button>',
      { noBar: true, noActions: true });
  }

  function addToCart(key, btn) {
    var prods = L.R[key].items.map(prod).filter(Boolean);
    var items = prods.map(function (p) { return { id: p.variant, quantity: 1 }; });
    var usaCodigo = prods.some(function (p) { return !onSale(p); });
    track('quiz_add_to_cart', { quiz_product: L.R[key].titulo });
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'QuizAddToCart', { content_name: L.R[key].titulo }); } catch (e) {}
    if (C.preview) { btn.textContent = '✓ Agregado (vista previa)'; return; }
    btn.disabled = true; btn.innerHTML = '<span class="cq-spin"></span>';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = usaCodigo ? '/discount/' + encodeURIComponent(C.code) + '?redirect=/cart' : '/cart'; })
      .catch(function () { btn.disabled = false; btn.textContent = 'No se pudo agregar, intenta de nuevo'; });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act],[data-add]');
    if (!t) return;
    if (t.hasAttribute('data-add')) return addToCart(t.getAttribute('data-add'), t);
    var a = t.getAttribute('data-act');
    if (a === 'start') { if (!started) { started = true; track('quiz_start', {}); } go('nombre'); }
    if (a === 'next') next();
    if (a === 'back') back();
    if (a === 'redo') { history = []; state.extras = []; state.necesidad = ''; state.pielResp = ''; go('para', false); }
    if (a === 'copy') {
      try { navigator.clipboard.writeText(C.code); } catch (er) {}
      t.textContent = '¡Copiado!'; setTimeout(function () { t.textContent = 'Copiar código'; }, 1800);
    }
  });

  render();
})();
